import { createContext, useContext } from "react";
import { MessageInstance } from "antd/es/message/interface";

export interface MessageContextType {
  messageApi: MessageInstance;
  messageContextHolder: React.ReactElement<
    unknown,
    string | React.JSXElementConstructor<unknown>
  >;
}

export const MessageContext = createContext<MessageContextType>(null!);

export const useMessage = () => useContext(MessageContext);
